import { useParams } from "react-router-dom";
import { usePublicOrganizationDevices } from "@/hooks/use-public-organization-devices";

export default function TestShowcase() {
  console.log('🧪 [TestShowcase] Component mounted');
  console.log('🧪 [TestShowcase] Location:', window.location.href);
  
  const { organizationId } = useParams<{ organizationId: string }>();
  console.log('🧪 [TestShowcase] Params:', { organizationId });
  
  const { data, isLoading, error } = usePublicOrganizationDevices(organizationId || "");
  
  console.log('🧪 [TestShowcase] Hook result:', { 
    hasData: !!data, 
    isLoading, 
    error: error instanceof Error ? error.message : error 
  });

  return (
    <div className="min-h-screen bg-background p-8">
      <h1 className="text-2xl font-bold mb-4">Test Showcase Page</h1>
      <div className="space-y-2 font-mono text-sm">
        <p>✅ Component Mounted Successfully</p>
        <p>Organization ID: {organizationId || 'NOT SET'}</p>
        <p>Loading: {isLoading ? 'YES' : 'NO'}</p>
        <p>Has Data: {data ? 'YES' : 'NO'}</p>
        <p>Has Error: {error ? 'YES' : 'NO'}</p>
        {error && <p className="text-destructive">Error: {error instanceof Error ? error.message : String(error)}</p>}
        {data && (
          <div className="mt-4 p-4 border rounded">
            <p>Organization: {data.organization?.name}</p>
            <p>Devices: {data.devices?.length || 0}</p>
          </div>
        )}
      </div>
    </div>
  );
}
